<div class="loader-wrapper" [class.hidden]="!show">
  <span class="loader"></span>
  </div>
